/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_SizeGuide_SizeGuide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/SizeGuide/SizeGuide */ "./resources/scripts/components/SizeGuide/SizeGuide.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_UsedSizes_UsedSizes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/UsedSizes/UsedSizes */ "./resources/scripts/components/UsedSizes/UsedSizes.ts");




var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
consent.init();
customElements.define('size-guide', _scripts_components_SizeGuide_SizeGuide__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('geolocator-component', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('used-sizes', _scripts_components_UsedSizes_UsedSizes__WEBPACK_IMPORTED_MODULE_3__["default"]);

/***/ }),

/***/ "./resources/scripts/components/Consent/Consent.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// - Ensure GDPR/CCPA compliance by providing legally required opt-in/opt-out functionality and transparency.
// - Refer to Shopify's privacy documentation for specific implementation requirements.
//
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
    this.logConsent = this.logConsent.bind(this);
  }
  // methods
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: 'consent-tracking-api',
                version: '0.1'
              }], function (error) {
                if (error) {
                  return;
                }
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener('visitorConsentCollected', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate('update');
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById('recall-consent');
              if (recallConsentElement) {
                recallConsentElement.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
                analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
                ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
                wait_for_update: 3000
              };
              this.gtag('consent', state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem('consentSettings', JSON.stringify(consent));
              this.logConsent(consent);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }() /* eslint-disable */)
  }, {
    key: "logConsent",
    value: (function () {
      var _logConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(consentSettings) {
        var _localStorage$getItem, userId, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              if (!((_localStorage$getItem = localStorage.getItem('userId')) !== null && _localStorage$getItem !== void 0)) {
                _context7.n = 1;
                break;
              }
              _t = _localStorage$getItem;
              _context7.n = 3;
              break;
            case 1:
              _context7.n = 2;
              return this.generateRandomHash();
            case 2:
              _t = _context7.v;
            case 3:
              userId = _t;
              localStorage.setItem('userId', userId);
              /* TODO: Add endpoint to log the users preferences for more compliance
                const logData = {
                user: USER_HERE,
                consentSettings,
                }
                       const response = await fetch('https://my-url/api/my-endpoint', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                });
                       if (!response.ok) {
                  throw new Error('Failed to log consent');
                }
                       const data = await response.json();
                console.log('Consent logged successfully: ', data);
                       COMMENT FOR ENDPOINT + DATABASE
                       When this event is recieved in the endpoint, the backend should first look at the website the request is coming from.
                If the request is coming from a website that is not allowed in our database, the request should be denied.
                This is to prevent unauthorized websites from logging consent settings, and to only allow websites that use our services to log consent settings.
                       After verifying the website, the backend should log the user's consent settings to a database
                If the user does not exist in the database, create a new entry for the user with the consent settings
                If the user exists in the database, update the user's consent settings with the new values
                       Database strucutre should be relational and could look like this:
                Each user / visitor belongs to a shop, and each shop can have multiple users / visitors
                Each user / visitor can have multiple consent settings
                       model: Shop
                       id | name | url | created_at | updated_at | user[]
                ---------------------------------------------------
                1  | Shop1| url1| 2021-09-01 | 2021-09-01 | [User1, User2, User3]
                       model: User
                       User | Functionality | Analytics | Personalization | Ad Storage | Ad User Data | Ad Personalization | created_at | updated_at | shop_id
                -------------------------------------------------------------------------------------------------------
                User1|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User2|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User3|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User4|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User5|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User6|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
              */
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t2 = _context7.v;
              console.error('Error logging consent: ', _t2);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 4]]);
      }));
      function logConsent(_x2) {
        return _logConsent.apply(this, arguments);
      }
      return logConsent;
    }())
  }, {
    key: "generateRandomHash",
    value: function () {
      var _generateRandomHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var randomHash;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              randomHash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
              return _context8.a(2, randomHash);
          }
        }, _callee8);
      }));
      function generateRandomHash() {
        return _generateRandomHash.apply(this, arguments);
      }
      return generateRandomHash;
    }()
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "countryData", void 0);
    _defineProperty(_this, "url", window.location.href);
    _defineProperty(_this, "swithcButtons", Array.from(document.querySelectorAll('.switch-button')));
    _defineProperty(_this, "geoPopupTriggers", Array.from(document.querySelectorAll('.geolocator-trigger')));
    _this.countryData = window.countryData;
    // bind the methods to the class
    _this.getSelectedCountry = _this.getSelectedCountry.bind(_this);
    _this.getVisitorCountry = _this.getVisitorCountry.bind(_this);
    _this.showGeoPopup = _this.showGeoPopup.bind(_this);
    _this.handleClickedStayButton = _this.handleClickedStayButton.bind(_this);
    _this.handleClickedRedirectButton = _this.handleClickedRedirectButton.bind(_this);
    _this.checkUrlForParam = _this.checkUrlForParam.bind(_this);
    _this.SortAndOrderCountries = _this.SortAndOrderCountries.bind(_this);
    _this.updateLocalization = _this.updateLocalization.bind(_this);
    _this.handleSwitchButtonClick = _this.handleSwitchButtonClick.bind(_this);
    _this.handleGeoPopupTriggerClick = _this.handleGeoPopupTriggerClick.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var editionGeoCookie, editionGeoSwitchCookie, _window, countryData, selectedCountry, visitorCountry, visitorCountryIsInCountryData, primaryCountryDataInCountryData, visitorCountryDataInCountryData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.checkUrlForParam();
              editionGeoCookie = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geocookie');
              editionGeoSwitchCookie = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)('edition-geoswitch');
              this.swithcButtons.forEach(function (button) {
                button.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.handleSwitchButtonClick(button);
                });
              });
              _window = window, countryData = _window.countryData;
              selectedCountry = this.getSelectedCountry();
              _context.n = 1;
              return this.getVisitorCountry();
            case 1:
              visitorCountry = _context.v;
              visitorCountryIsInCountryData = countryData.some(function (country) {
                return country.countryCode === visitorCountry.handle;
              });
              primaryCountryDataInCountryData = countryData.find(function (country) {
                return country.primaryCountry === true;
              });
              visitorCountryDataInCountryData = countryData.find(function (country) {
                return country.countryCode === visitorCountry.handle;
              });
              this.geoPopupTriggers.forEach(function (trigger) {
                console.log('trigger', trigger);
                trigger.addEventListener('click', function (event) {
                  event.preventDefault();
                  _this2.handleGeoPopupTriggerClick(visitorCountryIsInCountryData ? visitorCountryDataInCountryData : primaryCountryDataInCountryData);
                });
              });
              if (!(editionGeoCookie || editionGeoSwitchCookie || Shopify.designMode === true)) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              console.log('selectedCountry', selectedCountry);
              console.log('visitorCountry', visitorCountry);
              if (selectedCountry.countryCode === visitorCountry.handle) {
                // console.log('Country match - no need for popup');
              } else if (!visitorCountryIsInCountryData) {
                this.showGeoPopup(primaryCountryDataInCountryData);
              } else {
                this.showGeoPopup(visitorCountryDataInCountryData);
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "getSelectedCountry",
    value: function getSelectedCountry() {
      var countryDataArray = this.countryData;
      var selectedCountry = countryDataArray.find(function (country) {
        return country.locale === Shopify.locale;
      });
      return selectedCountry;
    }
  }, {
    key: "getVisitorCountry",
    value: function () {
      var _getVisitorCountry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, visitorCountry;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('/browsing_context_suggestions.json');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              visitorCountry = data.detected_values.country;
              this.setAttribute('data-visitor-country', visitorCountry.handle);
              return _context2.a(2, visitorCountry);
          }
        }, _callee2, this);
      }));
      function getVisitorCountry() {
        return _getVisitorCountry.apply(this, arguments);
      }
      return getVisitorCountry;
    }()
  }, {
    key: "showGeoPopup",
    value: function showGeoPopup(countryObject) {
      var _this3 = this;
      this.classList.remove('tw-z-[-1]');
      this.classList.add('tw-z-[10000]');
      setTimeout(function () {
        _this3.classList.add('!tw-opacity-100');
      }, 500);
      var layout = this.dataset.layout;
      if (layout === 'primary') {
        var imgContainer = this.querySelector('#geolocator-flag');
        var heading = this.querySelector('#geolocator-heading');
        var richtext = this.querySelector('#geolocator-richtext');
        var buttonRedirect = this.querySelector('#geolocator-button-redirect');
        var buttonStay = this.querySelector('#geolocator-button-stay');
        if (imgContainer) {
          if (countryObject.flag !== '') {
            imgContainer.innerHTML = "<img src=\"".concat(countryObject.flag, "\" class=\"tw-h-max tw-w-full tw-object-contain\">");
          }
        }
        heading.innerHTML = countryObject.heading;
        richtext.innerText = countryObject.richtext;
        buttonRedirect.innerHTML = countryObject.button_one;
        buttonStay.innerHTML = countryObject.button_two;
        // If the user clicks the "redirect" button, redirect to the selected country or market
        buttonRedirect.addEventListener('click', this.handleClickedRedirectButton.bind(this, countryObject));
        // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
        buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
      } else {
        var _heading = this.querySelector('#geolocator-heading');
        var _richtext = this.querySelector('#geolocator-richtext');
        var _buttonStay = this.querySelector('#geolocator-button-stay');
        this.SortAndOrderCountries(countryObject);
        _heading.innerHTML = countryObject.heading;
        _buttonStay.innerHTML = countryObject.button_two;
        // If the user clicks the "stay" button, set a cookie to prevent the popup from showing again for 10 minutes
        _buttonStay.addEventListener('click', this.handleClickedStayButton.bind(this));
      }
    }
  }, {
    key: "handleClickedStayButton",
    value: function handleClickedStayButton() {
      var _this4 = this;
      this.classList.remove('tw-opacity-100');
      this.classList.add('tw-opacity-0');
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geocookie', 'true', 10);
      setTimeout(function () {
        _this4.remove();
      }, 1000);
    }
  }, {
    key: "handleClickedRedirectButton",
    value: function handleClickedRedirectButton(countryObject) {
      this.remove();
      var storeType = countryObject.type;
      if (storeType === 'Country') {
        var redirectUrl = countryObject.link;
        window.location.href = redirectUrl;
      } else if (storeType === 'Market') {
        var code = countryObject.countryCode;
        var countryLocale = countryObject.locale;
        this.updateLocalization(code, countryLocale);
      }
    }
  }, {
    key: "checkUrlForParam",
    value: function checkUrlForParam() {
      if (this.url.includes('?edition-geoswitch')) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geoswitch', 'true', 10);
      }
    }
  }, {
    key: "SortAndOrderCountries",
    value: function SortAndOrderCountries(countryObject) {
      var currentCountryListHolder = this.querySelector('#geolocator-country-list');
      var currentCountryList = Array.from(currentCountryListHolder.querySelectorAll('.geolocator_country'));
      // Each geolocator_country has a data-locale attribute. Sort the currentCountryList based on the data-locale attribute so the country that has the same locale as the countryObject is first in the list
      currentCountryList.sort(function (a, b) {
        if (a.dataset.locale === countryObject.locale) {
          return -1;
        }
        if (b.dataset.locale === countryObject.locale) {
          return 1;
        }
        return 0;
      });
      // Add the sorted list back to the DOM
      currentCountryList.forEach(function (country) {
        currentCountryListHolder.appendChild(country);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateLocalization",
    value: function updateLocalization(countryCode, countryLocale) {
      var randomFormId = Math.random().toString(36).substring(7);
      var formHtml = "\n    <form id=\"".concat(randomFormId, "\" action=\"/localization\" method=\"POST\" hidden>\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"").concat(countryCode, "\">\n      <input name=\"language_code\" value=\"").concat(countryLocale, "\">\n    </form>\n  ");
      document.body.insertAdjacentHTML('beforeend', formHtml);
      var form = document.getElementById(randomFormId);
      form.submit();
    }
  }, {
    key: "handleSwitchButtonClick",
    value: function handleSwitchButtonClick(button) {
      var type = button.dataset.type;
      if (type === 'Market') {
        var _button$dataset = button.dataset,
          handle = _button$dataset.handle,
          locale = _button$dataset.locale;
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)('edition-geocookie', 'true', 1 * 60 * 24);
        this.updateLocalization(handle, locale);
      } else {
        window.location.href = button.href;
      }
    }
  }, {
    key: "handleGeoPopupTriggerClick",
    value: function handleGeoPopupTriggerClick(countryData) {
      this.showGeoPopup(countryData);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/SizeGuide/SizeGuide.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/SizeGuide/SizeGuide.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SizeGuide)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SizeGuide = /*#__PURE__*/function (_HTMLElement) {
  function SizeGuide() {
    var _this;
    _classCallCheck(this, SizeGuide);
    _this = _callSuper(this, SizeGuide);
    _defineProperty(_this, "tabs", Array.from(_this.querySelectorAll('.sizeguide-tab')));
    _defineProperty(_this, "tabContents", Array.from(_this.querySelectorAll('.sizeguide-content')));
    _this.handleTabClick = _this.handleTabClick.bind(_this);
    return _this;
  }
  _inherits(SizeGuide, _HTMLElement);
  return _createClass(SizeGuide, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.handleTabClick(tab);
        });
      });
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(tab) {
      this.tabs.forEach(function (t) {
        return t.classList.remove('selected-tab');
      });
      tab.classList.add('selected-tab');
      var selectedTab = tab.dataset.gender;
      var selectedContentTab = this.tabContents.find(function (contentTab) {
        return contentTab.dataset.gender === selectedTab;
      });
      this.tabContents.forEach(function (contentTab) {
        return contentTab.classList.remove('selected-content');
      });
      selectedContentTab.classList.add('selected-content');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/UsedSizes/UsedSizes.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/UsedSizes/UsedSizes.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ UsedSizes)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UsedSizes = /*#__PURE__*/function (_HTMLElement) {
  function UsedSizes() {
    var _this;
    _classCallCheck(this, UsedSizes);
    _this = _callSuper(this, UsedSizes);
    // Elements
    _defineProperty(_this, "modal", null);
    _defineProperty(_this, "openButton", null);
    _defineProperty(_this, "modalCloseButton", null);
    _defineProperty(_this, "modalBackdrop", null);
    _defineProperty(_this, "mainImg", null);
    _defineProperty(_this, "prevBtn", null);
    _defineProperty(_this, "nextBtn", null);
    _defineProperty(_this, "thumbs", []);
    _defineProperty(_this, "counterCurrent", null);
    _defineProperty(_this, "counterTotal", null);
    // State
    _defineProperty(_this, "currentIndex", 0);
    _defineProperty(_this, "total", 0);
    _defineProperty(_this, "touchStartX", null);
    // Data
    _defineProperty(_this, "producturl", null);
    // Listener lifecycle
    _defineProperty(_this, "listeners", void 0);
    // Keep track of modal even when moved to <body>
    _defineProperty(_this, "modalId", void 0);
    // Animation state
    _defineProperty(_this, "isAnimating", false);
    _defineProperty(_this, "prefersReducedMotion", typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    // Stable handler refs
    _defineProperty(_this, "onVariantChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var detail, _ref2, variant;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              detail = event.detail;
              _ref2 = detail || {}, variant = _ref2.variant;
              if (!((variant === null || variant === void 0 ? void 0 : variant.id) != null)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this.reInitComponent(Number(variant.id));
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onKeyDown", function (e) {
      if (!_this.modal || _this.modal.classList.contains('tw-hidden')) return;
      if (e.key === 'Escape') _this.closeModal();
      if (e.key === 'ArrowRight') _this.next();
      if (e.key === 'ArrowLeft') _this.prev();
    });
    _this.initElements = _this.initElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.teardownListeners = _this.teardownListeners.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.goTo = _this.goTo.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.prev = _this.prev.bind(_this);
    return _this;
  }
  _inherits(UsedSizes, _HTMLElement);
  return _createClass(UsedSizes, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initElements();
      this.addEventListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.teardownListeners();
      // If the modal was moved to <body>, clean it up to avoid orphans
      if (this.modal && this.modal.parentElement === document.body) {
        document.body.removeChild(this.modal);
      }
    }
    // -- Setup / init -----------------------------------------------------------
  }, {
    key: "initElements",
    value: function initElements() {
      var _this$dataset$product;
      // dataset.producturl maps to data-producturl in HTML
      this.producturl = (_this$dataset$product = this.dataset.producturl) !== null && _this$dataset$product !== void 0 ? _this$dataset$product : null;
      // Query inside the component
      this.openButton = this.querySelector('[data-role="open"]');
      // The modal might be inside the component OR already moved to <body>
      this.modal = this.querySelector('[data-role="modal"]') || (this.modalId ? document.getElementById(this.modalId) : null);
      if (this.modal && !this.modalId) {
        // Assign a stable id once so we can always find it even in <body>
        this.modalId = this.modal.id || "used-sizes-modal-".concat(Math.random().toString(36).slice(2));
        this.modal.id = this.modalId;
      }
      // Modal-scoped elements can be found relative to modal if present
      var modalRoot = this.modal || this;
      this.modalCloseButton = modalRoot.querySelector('[data-role="close"]');
      this.modalBackdrop = modalRoot.querySelector('[data-role="backdrop"]');
      this.mainImg = this.querySelector('[data-role="main"]');
      this.prevBtn = this.querySelector('[data-role="prev"]');
      this.nextBtn = this.querySelector('[data-role="next"]');
      this.counterCurrent = this.querySelector('[data-role="counter-current"]');
      this.counterTotal = this.querySelector('[data-role="counter-total"]');
      this.thumbs = Array.from(this.querySelectorAll('.used-sizes-thumb'));
      this.total = this.thumbs.length;
      if (this.counterTotal) this.counterTotal.textContent = String(this.total);
    }
  }, {
    key: "teardownListeners",
    value: function teardownListeners() {
      if (this.listeners) {
        this.listeners.abort(); // removes ALL listeners that were registered with this signal
        this.listeners = undefined;
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$openButton,
        _this$modalCloseButto,
        _this2 = this,
        _this$modalBackdrop,
        _this$prevBtn,
        _this$nextBtn,
        _this$mainImg,
        _this$mainImg2;
      // Always clear old listeners before adding new ones
      this.teardownListeners();
      this.listeners = new AbortController();
      var signal = this.listeners.signal;
      (_this$openButton = this.openButton) === null || _this$openButton === void 0 || _this$openButton.addEventListener('click', this.openModal, {
        signal: signal
      });
      (_this$modalCloseButto = this.modalCloseButton) === null || _this$modalCloseButto === void 0 || _this$modalCloseButto.addEventListener('click', function (e) {
        e.preventDefault();
        _this2.closeModal();
      }, {
        signal: signal
      });
      (_this$modalBackdrop = this.modalBackdrop) === null || _this$modalBackdrop === void 0 || _this$modalBackdrop.addEventListener('click', this.closeModal, {
        signal: signal
      });
      (_this$prevBtn = this.prevBtn) === null || _this$prevBtn === void 0 || _this$prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.prev();
      }, {
        signal: signal
      });
      (_this$nextBtn = this.nextBtn) === null || _this$nextBtn === void 0 || _this$nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.next();
      }, {
        signal: signal
      });
      this.thumbs.forEach(function (btn) {
        return btn.addEventListener('click', function () {
          var _btn$dataset$index;
          var idx = Number((_btn$dataset$index = btn.dataset.index) !== null && _btn$dataset$index !== void 0 ? _btn$dataset$index : 0);
          _this2.goTo(idx);
        }, {
          signal: signal
        });
      });
      document.addEventListener('keydown', this.onKeyDown, {
        signal: signal
      });
      // Swipe handlers on the main image
      (_this$mainImg = this.mainImg) === null || _this$mainImg === void 0 || _this$mainImg.addEventListener('touchstart', function (e) {
        _this2.touchStartX = e.changedTouches[0].clientX;
      }, {
        passive: true,
        signal: signal
      });
      (_this$mainImg2 = this.mainImg) === null || _this$mainImg2 === void 0 || _this$mainImg2.addEventListener('touchend', function (e) {
        if (_this2.touchStartX == null) return;
        var dx = e.changedTouches[0].clientX - _this2.touchStartX;
        if (dx > 30) _this2.prev();
        if (dx < -30) _this2.next();
        _this2.touchStartX = null;
      }, {
        passive: true,
        signal: signal
      });
      // Variant change (single stable handler)
      document.addEventListener('edition-variant-changed', this.onVariantChange, {
        signal: signal
      });
    }
    // -- Re-init on variant change ----------------------------------------------
  }, {
    key: "reInitComponent",
    value: function () {
      var _reInitComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(variantId) {
        var productUrl, url, response, text, doc, newComponent, frag, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              productUrl = this.producturl;
              if (productUrl) {
                _context2.n = 1;
                break;
              }
              console.warn('UsedSizes reinit: missing data-producturl');
              return _context2.a(2);
            case 1:
              url = "".concat(productUrl, "?variant=").concat(variantId);
              _context2.n = 2;
              return fetch(url, {
                credentials: 'same-origin'
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 3;
                break;
              }
              console.warn('UsedSizes reinit: fetch failed', response.status, url);
              return _context2.a(2);
            case 3:
              _context2.n = 4;
              return response.text();
            case 4:
              text = _context2.v;
              doc = new DOMParser().parseFromString(text, 'text/html');
              newComponent = doc.querySelector('used-sizes'); // If modal is currently in <body>, move it back inside before we replace children
              if (this.modal && this.modal.parentElement === document.body) {
                this.appendChild(this.modal);
              }
              // Remove listeners tied to old nodes
              this.teardownListeners();
              // Replace children safely (avoid innerHTML quirks)
              frag = document.createDocumentFragment();
              if (newComponent) {
                Array.from(newComponent.childNodes).forEach(function (n) {
                  return frag.appendChild(n.cloneNode(true));
                });
              }
              this.replaceChildren(frag);
              // Re-grab elements & wire listeners
              this.initElements();
              this.addEventListeners();
              // Reset state & sync UI
              this.currentIndex = 0;
              this.goTo(0);
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              console.error('Error re-initializing UsedSizes component:', _t);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function reInitComponent(_x2) {
        return _reInitComponent.apply(this, arguments);
      }
      return reInitComponent;
    }() // -- Modal controls ----------------------------------------------------------
  }, {
    key: "openModal",
    value: function openModal() {
      if (!this.modal) return;
      // Move modal to body for z-index/overflow safety (before showing)
      if (this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal);
      }
      this.modal.classList.remove('tw-hidden');
      document.body.style.overflow = 'hidden';
      // Sync UI
      this.goTo(this.currentIndex);
      if (this.prefersReducedMotion) return;
      // Animate in: backdrop fades, dialog pops
      var backdrop = this.modal.querySelector('[data-role="backdrop"]');
      var dialog = this.modal.querySelector('.tw-bg-white.tw-rounded-lg');
      if (backdrop) {
        backdrop.classList.add('us-modal-enter');
        requestAnimationFrame(function () {
          backdrop.classList.add('us-modal-enter-active');
          backdrop.classList.remove('us-modal-enter');
        });
      }
      if (dialog) {
        dialog.classList.add('us-dialog-enter');
        requestAnimationFrame(function () {
          dialog.classList.add('us-dialog-enter-active');
          dialog.classList.remove('us-dialog-enter');
          var _done = function done() {
            dialog.classList.remove('us-dialog-enter-active');
            dialog.removeEventListener('transitionend', _done);
          };
          dialog.addEventListener('transitionend', _done);
        });
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this3 = this;
      if (!this.modal) return;
      if (this.prefersReducedMotion) {
        this.modal.classList.add('tw-hidden');
        document.body.style.overflow = '';
        if (!this.contains(this.modal)) this.appendChild(this.modal);
        return;
      }
      var backdrop = this.modal.querySelector('[data-role="backdrop"]');
      var dialog = this.modal.querySelector('.tw-bg-white.tw-rounded-lg');
      var pending = 0;
      var finish = function finish() {
        pending = -1;
        if (pending > 0) return;
        // Hide + cleanup exactly after animations
        _this3.modal.classList.add('tw-hidden');
        document.body.style.overflow = '';
        // Move it back inside the component for lifecycle management
        if (!_this3.contains(_this3.modal)) _this3.appendChild(_this3.modal);
        // Remove classes
        backdrop === null || backdrop === void 0 || backdrop.classList.remove('us-modal-leave-active', 'us-modal-leave');
        dialog === null || dialog === void 0 || dialog.classList.remove('us-dialog-leave-active', 'us-dialog-leave');
      };
      // Animate out
      if (backdrop) {
        pending = +1;
        backdrop.classList.add('us-modal-leave');
        requestAnimationFrame(function () {
          backdrop.classList.add('us-modal-leave-active');
          backdrop.classList.remove('us-modal-leave');
          backdrop.addEventListener('transitionend', finish, {
            once: true
          });
        });
      }
      if (dialog) {
        pending = +1;
        dialog.classList.add('us-dialog-leave');
        requestAnimationFrame(function () {
          dialog.classList.add('us-dialog-leave-active');
          dialog.classList.remove('us-dialog-leave');
          dialog.addEventListener('transitionend', finish, {
            once: true
          });
        });
      }
      // Fallback if nothing animated (e.g., CSS missing)
      if (pending === 0) finish();
    }
    // -- Gallery logic -----------------------------------------------------------
  }, {
    key: "goTo",
    value: function () {
      var _goTo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(index) {
        var targetIndex, same, btn, full, srcset, alt, pre, direction, activeBtn, _t2, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(!this.mainImg || this.total === 0)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              targetIndex = (index + this.total) % this.total;
              same = targetIndex === this.currentIndex;
              btn = this.thumbs[targetIndex];
              full = (btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-full')) || '';
              srcset = (btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-srcset')) || '';
              alt = (btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-alt')) || this.mainImg.alt || ''; // If no new image URL, still ensure UI state is correct
              if (full) {
                _context3.n = 2;
                break;
              }
              this.updateUIState(targetIndex);
              return _context3.a(2);
            case 2:
              _context3.p = 2;
              pre = new Image();
              pre.src = full;
              // (optional) Some browsers support decode()
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              _t2 = pre.decode;
              if (!_t2) {
                _context3.n = 3;
                break;
              }
              _context3.n = 3;
              return pre.decode();
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
            case 5:
              if (!(this.prefersReducedMotion || this.isAnimating || same)) {
                _context3.n = 6;
                break;
              }
              // Immediate swap (or same index: just ensure UI up-to-date)
              this.currentIndex = targetIndex;
              // 🔧 KEY FIX: update both src and srcset (or clear srcset)
              this.mainImg.src = full;
              if (srcset) {
                this.mainImg.srcset = srcset;
              } else {
                this.mainImg.removeAttribute('srcset');
              }
              this.mainImg.alt = alt;
              this.mainImg.setAttribute('data-index', String(this.currentIndex));
              // eslint-disable-next-line spaced-comment
              this.updateUIState(targetIndex, /*scroll*/true);
              return _context3.a(2);
            case 6:
              // Animated transition
              this.isAnimating = true;
              direction = this.getDirection(this.currentIndex, targetIndex); // Slide OUT current
              _context3.n = 7;
              return this.animateSlide(this.mainImg, 'out', direction);
            case 7:
              // Swap
              this.currentIndex = targetIndex;
              // 🔧 KEY FIX again during animated path
              this.mainImg.src = full;
              if (srcset) {
                this.mainImg.srcset = srcset;
              } else {
                this.mainImg.removeAttribute('srcset');
              }
              this.mainImg.alt = alt;
              this.mainImg.setAttribute('data-index', String(this.currentIndex));
              this.updateUIState(targetIndex, false);
              // Slide IN
              _context3.n = 8;
              return this.animateSlide(this.mainImg, 'in', direction);
            case 8:
              // Scroll the active thumb into view (after paint)
              activeBtn = this.thumbs[this.currentIndex];
              activeBtn === null || activeBtn === void 0 || activeBtn.scrollIntoView({
                inline: 'center',
                behavior: 'smooth',
                block: 'nearest'
              });
              this.isAnimating = false;
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function goTo(_x3) {
        return _goTo.apply(this, arguments);
      }
      return goTo;
    }()
  }, {
    key: "next",
    value: function next() {
      this.goTo(this.currentIndex + 1);
    }
  }, {
    key: "prev",
    value: function prev() {
      this.goTo(this.currentIndex - 1);
    }
    // -- Helpers ----------------------------------------------------------------
  }, {
    key: "updateUIState",
    value: function updateUIState(idx) {
      var scroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.counterCurrent) this.counterCurrent.textContent = String(idx + 1);
      if (this.counterTotal) this.counterTotal.textContent = String(this.total);
      this.thumbs.forEach(function (b, i) {
        var active = i === idx;
        b.setAttribute('aria-selected', String(active));
        b.classList.toggle('tw-border-black', active);
      });
      if (scroll) {
        var _this$thumbs$idx;
        (_this$thumbs$idx = this.thumbs[idx]) === null || _this$thumbs$idx === void 0 || _this$thumbs$idx.scrollIntoView({
          inline: 'center',
          behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          block: 'nearest'
        });
      }
    }
  }, {
    key: "getDirection",
    value: function getDirection(from, to) {
      // Choose the shorter wrap direction so last<->first feels natural
      var forward = (to - from + this.total) % this.total;
      var backward = (from - to + this.total) % this.total;
      return forward <= backward ? 1 : -1;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "animateSlide",
    value: function animateSlide(el, phase, dir) {
      // Web Animations API for smooth, GPU-friendly transitions
      var distance = 24 * dir; // px; subtle keeps it classy
      var keyframes = phase === 'out' ? [{
        opacity: 1,
        transform: 'translateX(0px)'
      }, {
        opacity: 0,
        transform: "translateX(".concat(-distance, "px)")
      }] : [{
        opacity: 0,
        transform: "translateX(".concat(distance, "px)")
      }, {
        opacity: 1,
        transform: 'translateX(0px)'
      }];
      var timing = {
        duration: phase === 'out' ? 160 : 200,
        easing: 'cubic-bezier(.2,.8,.2,1)',
        fill: 'both'
      };
      try {
        el.classList.add('us-slide');
        var anim = el.animate ? el.animate(keyframes, timing) : null;
        if (!anim) {
          el.classList.remove('us-slide');
          return Promise.resolve();
        }
        return new Promise(function (res) {
          anim.addEventListener('finish', function () {
            el.classList.remove('us-slide');
            res();
          });
        });
      } catch (_unused2) {
        el.classList.remove('us-slide');
        return Promise.resolve();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deleteCookie": () => (/* binding */ deleteCookie),
/* harmony export */   "getCookie": () => (/* binding */ getCookie),
/* harmony export */   "setCookie": () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/src/assets/app": 0,
/******/ 			"src/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkthesneakstoredk"] = self["webpackChunkthesneakstoredk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["src/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;